// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import apis from './request/apis'
window.commonLogan = (require('./request/loganMethod')).commonLogan;
import './commonjs/vuePrototype.js';
import "./iconfont/iconfont.js";
import { NavBar, Dialog, Toast } from 'vant';
window.projectRuleObj = (require('@/commonjs/projectRule.js')).projectRuleObj;
import store from './vuex/store';
window.commonObj = (require('@/commonjs/common.js')).commonObj;
// window.areaMapObj = (require('@/commonjs/areaMap.js')).areaMapObj;
window.utilsObj = (require('@/commonjs/utils.js')).utilsObj;
window.uploadFileObj = (require('@/commonjs/uploadFile.js')).uploadFileObj;
import VuePageStack from 'vue-page-stack';
import APlayer from '@moefe/vue-aplayer';

import Meta from "vue-meta";

import markdownIt from 'markdown-it';

import waterfall from 'vue-waterfall2';
Vue.use(waterfall)
import AMap from 'vue-amap';
Vue.use(AMap);
const md = markdownIt();
md.use(require('markdown-it-lazy-headers'));
Vue.prototype.$md = md;

window._AMapSecurityConfig = {
	//serviceHost: '',
	securityJsCode: 'b0e15ef8871b63452afc26152627882c',//'c45adea4cf9b21e9fd4b8d687609bbe0',
}
// 初始化vue-amap
AMap.initAMapApiLoader({
	// 高德key
	key:'72899804ef76c30b8a13fa5a45c27986',// "71c6a57b779b2655b80412c47378aba8",
	// securityJsCode:"c45adea4cf9b21e9fd4b8d687609bbe0",
	// 插件集合 （插件按需引入）
	plugin: ['AMap.Geolocation', 'AMap.Autocomplete']
});



Vue.use(Meta);

Vue.prototype.$axios = axios;

Vue.config.productionTip = false

Vue.prototype.$api = apis;

Vue.use(NavBar);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(VuePageStack, { router });
Vue.use(APlayer, {
	defaultCover: '',
	productionTip: true,
});

store.state.stateObject.tokenRefreshTime=new Date();
var index = navigator.userAgent.split(" ").length;
// if (navigator.userAgent.split(" ")[index - 1].length < 30) {
	if (navigator.userAgent.indexOf("os-name/android")==-1) {
	if (process.env.NODE_ENV === "development") {
		var userInfo1 = {
    "staffId": "df00b9ab6ebc3ab01753f8e00a4b9409",
    "companyId": "0201b4ab530b9ffe2fe72152fe4ab195",
    "companyName": "成都总公司",
    "jobState": 2,
    "roleLevelName": "",
    "name": "黄芳",
    "phone": "15520666666",
    "pwd": null,
    "headPic": "https://c-ssl.dtstatic.com/uploads/blog/202208/02/20220802031407_96f49.thumb.400_0.jpeg",
    "pic": "",
    "entryDate": null,
    "state": 0,
    "deptId": 103,
    "expandManage": null,
    "actions": null,
    "roleList": null,
    "map": null,
    "commentStaffId": null,
    "commentStaffName": null,
    "busPhone": "18782004619",
    "token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjb21wYW55SWQiOiIwMjAxYjRhYjUzMGI5ZmZlMmZlNzIxNTJmZTRhYjE5NSIsImxvZ2luTmFtZSI6IjE1NTIwNjY2NjY2Iiwic3RhZmZOYW1lIjoi6buE6IqzIiwic3RhZmZJZCI6ImRmMDBiOWFiNmViYzNhYjAxNzUzZjhlMDBhNGI5NDA5IiwiaWF0IjoxNzYzNDQ2MDYyLCJleHAiOjE3NjM1MzI0NjIsIm5iZiI6MTc2MzQ0NjA2Mn0.LzKfrVtb1sA0dTWVM5455ZFTsBcHN6qhWiax0zOdc58",
    "deviceNumber": null,
    "isOpen": 1,
    "isFaceClockIn": null,
    "sts": null,
    "isWatermark": 1,
    "collectName": null,
    "companyRoleResps": [
      {
        "companyId": "0201b4ab530b9ffe2fe72152fe4ab195",
        "companyName": "成都总公司",
        "roleId": null,
        "staffId": null,
        "actions": [
          "projectListSalesSecretary",
          "projectListAllMisnister",
          "headBanner",
          "endPressMoney",
          "pressForMoneyList",
          "PressByProject",
          "endPressMoneyDev",
          "pressForMoneyListDev",
          "showOAHandle",
          "logPositionSearch",
          "showLog",
          "showExpandProjectList",
          "showProjectAuditMarkPerson",
          "showExpandProjectFollow",
          "showExpandResList",
          "searchResListPerson",
          "showDeleteResourceBotton",
          "showExpandResFollow",
          "searchResFollow",
          "showExpandPersonInventory",
          "showExpandStatistics",
          "showExpandProjectWaitFollow",
          "showResWaitFollow",
          "showClause",
          "showExpandContract",
          "showExpandWaitReceive",
          "showExpandLog",
          "showExpandPositionSearch",
          "showRecordingModule",
          "searchOther",
          "showResourceGiftList",
          "showSearchList",
          "scoreDifficultyTable",
          "projectOpeningTable",
          "projectStandardTable",
          "showDevelopers",
          "searchOtherDV",
          "showBond",
          "betweenTwoPartiesList",
          "showPaymentApproved",
          "showSalesList",
          "pressForDepositMoneyList",
          "OAInport",
          "lostOrReportedLoss",
          "proCustomerServiceFee",
          "OADevInport",
          "showSheetData",
          "paymentList",
          "showDailyReport",
          "sendGiftMore",
          "showSalaryRank",
          "competitor",
          "projectMsg",
          "proprietorMsg",
          "signingMsg",
          "stockMsg",
          "resourcesMsg",
          "financeMsg",
          "parkingLotMsg",
          "staffMsg",
          "collectionMsg",
          "selfMsg",
          "helpMsg",
          "pressForDepositMoneyListDev",
          "contactDelay",
          "advancePayment",
          "showWorkOrderExpand",
          "showProjectPKList",
          "auditPKList",
          "auditPKBotton",
          "showDevProjectPKList",
          "monthlyReview",
          "showsurveyByQuestionnaireList",
          "investigateReport",
          "developerToBeSupplemented",
          "businessTermsList",
          "friendCircleMaterialExpand",
          "borrowingRecords",
          "borrowingRecordsDev",
          "contractList",
          "devScoreList",
          "mortgageDocumentList",
          "showDetentionBtn",
          "showMortgageDocument",
          "showDetentionBtnDev",
          "replayList",
          "deliver",
          "proCustomerServiceFeeExpand",
          "showToDoList",
          "showExpandCollectProject",
          "showCommercialTerms",
          "showDraftContractList",
          "showCommercialTermsList",
          "showWithdrawalMeeting",
          "withdrawalTimeAudit",
          "showProjectInventoryForPersonal",
          "bankAccountBalance",
          "ProjectFlowAudit",
          "propertyToBeSupplemented",
          "practiseEveryWeekDev",
          "collegeTaskDev",
          "practiseEveryDayDev",
          "showDevelopPKList",
          "importantToDoListSale",
          "importantToDoListDev",
          "replayRecord",
          "showsurveyByQuestionnaireListDev",
          "scanStreetDev",
          "expectSignProjectList",
          "expectSignProjectListOther",
          "reserveProjectsList",
          "resourceTransmitList",
          "replayRecordDev",
          "meetingManageDev",
          "meetingManageSale",
          "showCustomersImport",
          "customerMagAllPerson",
          "businessCardEntrance",
          "businessCardDynamicListEntrance",
          "businessCardRelated",
          "resourceRecommendList",
          "projectListAllManager",
          "projectEdit",
          "devInfo",
          "addEntrance",
          "updateEntrance",
          "showProjectList",
          "businessTermContract",
          "projectInport",
          "workBordContractManage",
          "manangerLogin",
          "showProjectProcess",
          "showCustomList",
          "searchOtherDataCustomList",
          "showCarportList",
          "editCarSetIsSale",
          "addParkingPlace",
          "showProjectInventory",
          "showManagerTeam",
          "showFollowUpRecords",
          "searchOtherDataFollowUpRecords",
          "showWaitCheck",
          "showWithdrawalList",
          "showWaitDistribution",
          "statisticsDetailManager",
          "statisticsDetailPerson",
          "statisticsDetailTimes",
          "showStatistics",
          "export",
          "wechartDataTotal",
          "showProjectProductOutputValue",
          "showCheckWork",
          "showGiftCheckList",
          "showCallRecordsForStaffAll",
          "showPendingCashCollection",
          "showPreferentialConditions",
          "personnelTransfer",
          "OaWeekPlant",
          "merchantPassList",
          "customerMaintenanceRecommendAudit",
          "showTraversallntegral",
          "showCapabilityCoefficient",
          "showManager",
          "showManagerRevenue",
          "showManagerSale",
          "showManagerProject",
          "beeAIMsg",
          "beeAIMsgScanAll",
          "speechcraftList",
          "speechcraftAuditList",
          "friendCircleMaterialSale",
          "showCollectProject",
          "showToDoListSale",
          "proprietorChatList",
          "showReviewedRecommender",
          "practiseEveryDay",
          "practiseEveryWeek",
          "passEveryWeek",
          "studyMap",
          "collegeTask",
          "newComerMentoringInport",
          "allPracticeOrPassWeek",
          "videoList",
          "speechcraftCollectList",
          "showWarehouseManage",
          "showInventoryleaveUnusedList",
          "showTransitReserveListList",
          "showSaleProcess",
          "showMinistersPatrol",
          "liveBroadcast",
          "minSysEntrance",
          "developerReceptionList",
          "developerReceptionListSale",
          "propertyViewingList",
          "propertyViewingAudit",
          "showOtherMoudle"
        ],
        "roleList": [
          {
            "roleId": 3,
            "roleLevel": 2,
            "roleName": "拓展总监",
            "actions": [
              "projectListSalesSecretary",
              "projectListAllMisnister",
              "headBanner",
              "endPressMoney",
              "pressForMoneyList",
              "PressByProject",
              "endPressMoneyDev",
              "pressForMoneyListDev",
              "showOAHandle",
              "logPositionSearch",
              "showLog",
              "showExpandProjectList",
              "showProjectAuditMarkPerson",
              "showExpandProjectFollow",
              "showExpandResList",
              "searchResListPerson",
              "showDeleteResourceBotton",
              "showExpandResFollow",
              "searchResFollow",
              "showExpandPersonInventory",
              "showExpandStatistics",
              "showExpandProjectWaitFollow",
              "showResWaitFollow",
              "showClause",
              "showExpandContract",
              "showExpandWaitReceive",
              "showExpandLog",
              "showExpandPositionSearch",
              "showRecordingModule",
              "searchOther",
              "showResourceGiftList",
              "showSearchList",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "showDevelopers",
              "searchOtherDV",
              "showBond",
              "betweenTwoPartiesList",
              "showPaymentApproved",
              "showSalesList",
              "pressForDepositMoneyList",
              "OAInport",
              "lostOrReportedLoss",
              "proCustomerServiceFee",
              "OADevInport",
              "showSheetData",
              "paymentList",
              "showDailyReport",
              "sendGiftMore",
              "showSalaryRank",
              "competitor",
              "projectMsg",
              "proprietorMsg",
              "signingMsg",
              "stockMsg",
              "resourcesMsg",
              "financeMsg",
              "parkingLotMsg",
              "staffMsg",
              "collectionMsg",
              "selfMsg",
              "helpMsg",
              "pressForDepositMoneyListDev",
              "contactDelay",
              "advancePayment",
              "showWorkOrderExpand",
              "showProjectPKList",
              "auditPKList",
              "auditPKBotton",
              "showDevProjectPKList",
              "monthlyReview",
              "showsurveyByQuestionnaireList",
              "investigateReport",
              "developerToBeSupplemented",
              "businessTermsList",
              "friendCircleMaterialExpand",
              "borrowingRecords",
              "borrowingRecordsDev",
              "contractList",
              "devScoreList",
              "mortgageDocumentList",
              "showDetentionBtn",
              "showMortgageDocument",
              "showDetentionBtnDev",
              "replayList",
              "deliver",
              "proCustomerServiceFeeExpand",
              "showToDoList",
              "showExpandCollectProject",
              "showCommercialTerms",
              "showDraftContractList",
              "showCommercialTermsList",
              "showWithdrawalMeeting",
              "withdrawalTimeAudit",
              "showProjectInventoryForPersonal",
              "bankAccountBalance",
              "ProjectFlowAudit",
              "propertyToBeSupplemented",
              "practiseEveryWeekDev",
              "collegeTaskDev",
              "practiseEveryDayDev",
              "showDevelopPKList",
              "importantToDoListSale",
              "importantToDoListDev",
              "replayRecord",
              "showsurveyByQuestionnaireListDev",
              "scanStreetDev",
              "expectSignProjectList",
              "expectSignProjectListOther",
              "reserveProjectsList",
              "resourceTransmitList",
              "replayRecordDev",
              "meetingManageDev",
              "meetingManageSale",
              "showCustomersImport",
              "customerMagAllPerson",
              "businessCardEntrance",
              "businessCardDynamicListEntrance",
              "businessCardRelated",
              "resourceRecommendList"
            ]
          },
          {
            "roleId": 4,
            "roleLevel": 2,
            "roleName": "销售总监",
            "actions": [
              "projectListAllManager",
              "projectEdit",
              "devInfo",
              "addEntrance",
              "updateEntrance",
              "showProjectList",
              "businessTermContract",
              "projectListSalesSecretary",
              "projectInport",
              "projectListAllMisnister",
              "headBanner",
              "workBordContractManage",
              "manangerLogin",
              "showProjectProcess",
              "showCustomList",
              "searchOtherDataCustomList",
              "showCarportList",
              "editCarSetIsSale",
              "addParkingPlace",
              "showProjectInventory",
              "showManagerTeam",
              "endPressMoney",
              "pressForMoneyList",
              "PressByProject",
              "endPressMoneyDev",
              "pressForMoneyListDev",
              "showFollowUpRecords",
              "searchOtherDataFollowUpRecords",
              "showWaitCheck",
              "showOAHandle",
              "showWithdrawalList",
              "showWaitDistribution",
              "statisticsDetailManager",
              "statisticsDetailPerson",
              "statisticsDetailTimes",
              "showStatistics",
              "export",
              "wechartDataTotal",
              "logPositionSearch",
              "showLog",
              "showExpandLog",
              "showExpandPositionSearch",
              "showProjectProductOutputValue",
              "showCheckWork",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "betweenTwoPartiesList",
              "showGiftCheckList",
              "showCallRecordsForStaffAll",
              "showPendingCashCollection",
              "showSalesList",
              "showPreferentialConditions",
              "pressForDepositMoneyList",
              "contactDelay",
              "OAInport",
              "personnelTransfer",
              "OaWeekPlant",
              "merchantPassList",
              "lostOrReportedLoss",
              "customerMaintenanceRecommendAudit",
              "proCustomerServiceFee",
              "OADevInport",
              "showSheetData",
              "showDailyReport",
              "sendGiftMore",
              "showSalaryRank",
              "showTraversallntegral",
              "showCapabilityCoefficient",
              "showManager",
              "showManagerRevenue",
              "showManagerSale",
              "showManagerProject",
              "competitor",
              "projectMsg",
              "signingMsg",
              "stockMsg",
              "resourcesMsg",
              "financeMsg",
              "parkingLotMsg",
              "staffMsg",
              "selfMsg",
              "beeAIMsg",
              "beeAIMsgScanAll",
              "pressForDepositMoneyListDev",
              "showProjectPKList",
              "auditPKList",
              "auditPKBotton",
              "showDevProjectPKList",
              "showsurveyByQuestionnaireList",
              "investigateReport",
              "speechcraftList",
              "speechcraftAuditList",
              "friendCircleMaterialSale",
              "borrowingRecords",
              "borrowingRecordsDev",
              "devScoreList",
              "mortgageDocumentList",
              "showCollectProject",
              "showToDoListSale",
              "proprietorChatList",
              "showReviewedRecommender",
              "showProjectInventoryForPersonal",
              "practiseEveryDay",
              "practiseEveryWeek",
              "passEveryWeek",
              "studyMap",
              "collegeTask",
              "newComerMentoringInport",
              "allPracticeOrPassWeek",
              "videoList",
              "speechcraftCollectList",
              "bankAccountBalance",
              "showWarehouseManage",
              "showInventoryleaveUnusedList",
              "showTransitReserveListList",
              "showSaleProcess",
              "importantToDoListSale",
              "importantToDoListDev",
              "showMinistersPatrol",
              "replayRecord",
              "meetingManageSale",
              "liveBroadcast",
              "businessCardEntrance",
              "businessCardDynamicListEntrance",
              "businessCardRelated",
              "minSysEntrance",
              "developerReceptionList",
              "developerReceptionListSale",
              "propertyViewingList",
              "propertyViewingAudit",
              "showOtherMoudle"
            ]
          },
          {
            "roleId": 34,
            "roleLevel": 3,
            "roleName": "调查员",
            "actions": []
          }
        ],
        "longitude": 104.07,
        "latitude": 30.65
      },
      {
        "companyId": "1999b009b2ed4dcaa8a2b8befabbb01e",
        "companyName": "山西分公司",
        "roleId": null,
        "staffId": null,
        "actions": [
          "projectListSalesSecretary",
          "projectListAllMisnister",
          "headBanner",
          "endPressMoney",
          "pressForMoneyList",
          "PressByProject",
          "endPressMoneyDev",
          "pressForMoneyListDev",
          "showOAHandle",
          "logPositionSearch",
          "showLog",
          "showExpandProjectList",
          "showProjectAuditMarkPerson",
          "showExpandProjectFollow",
          "showExpandResList",
          "searchResListPerson",
          "showDeleteResourceBotton",
          "showExpandResFollow",
          "searchResFollow",
          "showExpandPersonInventory",
          "showExpandStatistics",
          "showExpandProjectWaitFollow",
          "showResWaitFollow",
          "showClause",
          "showExpandContract",
          "showExpandWaitReceive",
          "showExpandLog",
          "showExpandPositionSearch",
          "showRecordingModule",
          "searchOther",
          "showResourceGiftList",
          "showSearchList",
          "scoreDifficultyTable",
          "projectOpeningTable",
          "projectStandardTable",
          "showDevelopers",
          "searchOtherDV",
          "showBond",
          "betweenTwoPartiesList",
          "showPaymentApproved",
          "showSalesList",
          "pressForDepositMoneyList",
          "OAInport",
          "lostOrReportedLoss",
          "proCustomerServiceFee",
          "OADevInport",
          "showSheetData",
          "paymentList",
          "showDailyReport",
          "sendGiftMore",
          "showSalaryRank",
          "competitor",
          "projectMsg",
          "proprietorMsg",
          "signingMsg",
          "stockMsg",
          "resourcesMsg",
          "financeMsg",
          "parkingLotMsg",
          "staffMsg",
          "collectionMsg",
          "selfMsg",
          "helpMsg",
          "pressForDepositMoneyListDev",
          "contactDelay",
          "advancePayment",
          "showWorkOrderExpand",
          "showProjectPKList",
          "auditPKList",
          "auditPKBotton",
          "showDevProjectPKList",
          "monthlyReview",
          "showsurveyByQuestionnaireList",
          "investigateReport",
          "developerToBeSupplemented",
          "businessTermsList",
          "friendCircleMaterialExpand",
          "borrowingRecords",
          "borrowingRecordsDev",
          "contractList",
          "devScoreList",
          "mortgageDocumentList",
          "showDetentionBtn",
          "showMortgageDocument",
          "showDetentionBtnDev",
          "replayList",
          "deliver",
          "proCustomerServiceFeeExpand",
          "showToDoList",
          "showExpandCollectProject",
          "showCommercialTerms",
          "showDraftContractList",
          "showCommercialTermsList",
          "showWithdrawalMeeting",
          "withdrawalTimeAudit",
          "showProjectInventoryForPersonal",
          "bankAccountBalance",
          "ProjectFlowAudit",
          "propertyToBeSupplemented",
          "practiseEveryWeekDev",
          "collegeTaskDev",
          "practiseEveryDayDev",
          "showDevelopPKList",
          "importantToDoListSale",
          "importantToDoListDev",
          "replayRecord",
          "showsurveyByQuestionnaireListDev",
          "scanStreetDev",
          "expectSignProjectList",
          "expectSignProjectListOther",
          "reserveProjectsList",
          "resourceTransmitList",
          "replayRecordDev",
          "meetingManageDev",
          "meetingManageSale",
          "showCustomersImport",
          "customerMagAllPerson",
          "businessCardEntrance",
          "businessCardDynamicListEntrance",
          "businessCardRelated",
          "resourceRecommendList",
          "projectListAllManager",
          "projectEdit",
          "devInfo",
          "addEntrance",
          "updateEntrance",
          "showProjectList",
          "businessTermContract",
          "projectInport",
          "workBordContractManage",
          "manangerLogin",
          "showProjectProcess",
          "showCustomList",
          "searchOtherDataCustomList",
          "showCarportList",
          "editCarSetIsSale",
          "addParkingPlace",
          "showProjectInventory",
          "showManagerTeam",
          "showFollowUpRecords",
          "searchOtherDataFollowUpRecords",
          "showWaitCheck",
          "showWithdrawalList",
          "showWaitDistribution",
          "statisticsDetailManager",
          "statisticsDetailPerson",
          "statisticsDetailTimes",
          "showStatistics",
          "export",
          "wechartDataTotal",
          "showProjectProductOutputValue",
          "showCheckWork",
          "showGiftCheckList",
          "showCallRecordsForStaffAll",
          "showPendingCashCollection",
          "showPreferentialConditions",
          "personnelTransfer",
          "OaWeekPlant",
          "merchantPassList",
          "customerMaintenanceRecommendAudit",
          "showTraversallntegral",
          "showCapabilityCoefficient",
          "showManager",
          "showManagerRevenue",
          "showManagerSale",
          "showManagerProject",
          "beeAIMsg",
          "beeAIMsgScanAll",
          "speechcraftList",
          "speechcraftAuditList",
          "friendCircleMaterialSale",
          "showCollectProject",
          "showToDoListSale",
          "proprietorChatList",
          "showReviewedRecommender",
          "practiseEveryDay",
          "practiseEveryWeek",
          "passEveryWeek",
          "studyMap",
          "collegeTask",
          "newComerMentoringInport",
          "allPracticeOrPassWeek",
          "videoList",
          "speechcraftCollectList",
          "showWarehouseManage",
          "showInventoryleaveUnusedList",
          "showTransitReserveListList",
          "showSaleProcess",
          "showMinistersPatrol",
          "liveBroadcast",
          "minSysEntrance",
          "developerReceptionList",
          "developerReceptionListSale",
          "propertyViewingList",
          "propertyViewingAudit",
          "showOtherMoudle"
        ],
        "roleList": [
          {
            "roleId": 3,
            "roleLevel": 2,
            "roleName": "拓展总监",
            "actions": [
              "projectListSalesSecretary",
              "projectListAllMisnister",
              "headBanner",
              "endPressMoney",
              "pressForMoneyList",
              "PressByProject",
              "endPressMoneyDev",
              "pressForMoneyListDev",
              "showOAHandle",
              "logPositionSearch",
              "showLog",
              "showExpandProjectList",
              "showProjectAuditMarkPerson",
              "showExpandProjectFollow",
              "showExpandResList",
              "searchResListPerson",
              "showDeleteResourceBotton",
              "showExpandResFollow",
              "searchResFollow",
              "showExpandPersonInventory",
              "showExpandStatistics",
              "showExpandProjectWaitFollow",
              "showResWaitFollow",
              "showClause",
              "showExpandContract",
              "showExpandWaitReceive",
              "showExpandLog",
              "showExpandPositionSearch",
              "showRecordingModule",
              "searchOther",
              "showResourceGiftList",
              "showSearchList",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "showDevelopers",
              "searchOtherDV",
              "showBond",
              "betweenTwoPartiesList",
              "showPaymentApproved",
              "showSalesList",
              "pressForDepositMoneyList",
              "OAInport",
              "lostOrReportedLoss",
              "proCustomerServiceFee",
              "OADevInport",
              "showSheetData",
              "paymentList",
              "showDailyReport",
              "sendGiftMore",
              "showSalaryRank",
              "competitor",
              "projectMsg",
              "proprietorMsg",
              "signingMsg",
              "stockMsg",
              "resourcesMsg",
              "financeMsg",
              "parkingLotMsg",
              "staffMsg",
              "collectionMsg",
              "selfMsg",
              "helpMsg",
              "pressForDepositMoneyListDev",
              "contactDelay",
              "advancePayment",
              "showWorkOrderExpand",
              "showProjectPKList",
              "auditPKList",
              "auditPKBotton",
              "showDevProjectPKList",
              "monthlyReview",
              "showsurveyByQuestionnaireList",
              "investigateReport",
              "developerToBeSupplemented",
              "businessTermsList",
              "friendCircleMaterialExpand",
              "borrowingRecords",
              "borrowingRecordsDev",
              "contractList",
              "devScoreList",
              "mortgageDocumentList",
              "showDetentionBtn",
              "showMortgageDocument",
              "showDetentionBtnDev",
              "replayList",
              "deliver",
              "proCustomerServiceFeeExpand",
              "showToDoList",
              "showExpandCollectProject",
              "showCommercialTerms",
              "showDraftContractList",
              "showCommercialTermsList",
              "showWithdrawalMeeting",
              "withdrawalTimeAudit",
              "showProjectInventoryForPersonal",
              "bankAccountBalance",
              "ProjectFlowAudit",
              "propertyToBeSupplemented",
              "practiseEveryWeekDev",
              "collegeTaskDev",
              "practiseEveryDayDev",
              "showDevelopPKList",
              "importantToDoListSale",
              "importantToDoListDev",
              "replayRecord",
              "showsurveyByQuestionnaireListDev",
              "scanStreetDev",
              "expectSignProjectList",
              "expectSignProjectListOther",
              "reserveProjectsList",
              "resourceTransmitList",
              "replayRecordDev",
              "meetingManageDev",
              "meetingManageSale",
              "showCustomersImport",
              "customerMagAllPerson",
              "businessCardEntrance",
              "businessCardDynamicListEntrance",
              "businessCardRelated",
              "resourceRecommendList"
            ]
          },
          {
            "roleId": 4,
            "roleLevel": 2,
            "roleName": "销售总监",
            "actions": [
              "projectListAllManager",
              "projectEdit",
              "devInfo",
              "addEntrance",
              "updateEntrance",
              "showProjectList",
              "businessTermContract",
              "projectListSalesSecretary",
              "projectInport",
              "projectListAllMisnister",
              "headBanner",
              "workBordContractManage",
              "manangerLogin",
              "showProjectProcess",
              "showCustomList",
              "searchOtherDataCustomList",
              "showCarportList",
              "editCarSetIsSale",
              "addParkingPlace",
              "showProjectInventory",
              "showManagerTeam",
              "endPressMoney",
              "pressForMoneyList",
              "PressByProject",
              "endPressMoneyDev",
              "pressForMoneyListDev",
              "showFollowUpRecords",
              "searchOtherDataFollowUpRecords",
              "showWaitCheck",
              "showOAHandle",
              "showWithdrawalList",
              "showWaitDistribution",
              "statisticsDetailManager",
              "statisticsDetailPerson",
              "statisticsDetailTimes",
              "showStatistics",
              "export",
              "wechartDataTotal",
              "logPositionSearch",
              "showLog",
              "showExpandLog",
              "showExpandPositionSearch",
              "showProjectProductOutputValue",
              "showCheckWork",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "betweenTwoPartiesList",
              "showGiftCheckList",
              "showCallRecordsForStaffAll",
              "showPendingCashCollection",
              "showSalesList",
              "showPreferentialConditions",
              "pressForDepositMoneyList",
              "contactDelay",
              "OAInport",
              "personnelTransfer",
              "OaWeekPlant",
              "merchantPassList",
              "lostOrReportedLoss",
              "customerMaintenanceRecommendAudit",
              "proCustomerServiceFee",
              "OADevInport",
              "showSheetData",
              "showDailyReport",
              "sendGiftMore",
              "showSalaryRank",
              "showTraversallntegral",
              "showCapabilityCoefficient",
              "showManager",
              "showManagerRevenue",
              "showManagerSale",
              "showManagerProject",
              "competitor",
              "projectMsg",
              "signingMsg",
              "stockMsg",
              "resourcesMsg",
              "financeMsg",
              "parkingLotMsg",
              "staffMsg",
              "selfMsg",
              "beeAIMsg",
              "beeAIMsgScanAll",
              "pressForDepositMoneyListDev",
              "showProjectPKList",
              "auditPKList",
              "auditPKBotton",
              "showDevProjectPKList",
              "showsurveyByQuestionnaireList",
              "investigateReport",
              "speechcraftList",
              "speechcraftAuditList",
              "friendCircleMaterialSale",
              "borrowingRecords",
              "borrowingRecordsDev",
              "devScoreList",
              "mortgageDocumentList",
              "showCollectProject",
              "showToDoListSale",
              "proprietorChatList",
              "showReviewedRecommender",
              "showProjectInventoryForPersonal",
              "practiseEveryDay",
              "practiseEveryWeek",
              "passEveryWeek",
              "studyMap",
              "collegeTask",
              "newComerMentoringInport",
              "allPracticeOrPassWeek",
              "videoList",
              "speechcraftCollectList",
              "bankAccountBalance",
              "showWarehouseManage",
              "showInventoryleaveUnusedList",
              "showTransitReserveListList",
              "showSaleProcess",
              "importantToDoListSale",
              "importantToDoListDev",
              "showMinistersPatrol",
              "replayRecord",
              "meetingManageSale",
              "liveBroadcast",
              "businessCardEntrance",
              "businessCardDynamicListEntrance",
              "businessCardRelated",
              "minSysEntrance",
              "developerReceptionList",
              "developerReceptionListSale",
              "propertyViewingList",
              "propertyViewingAudit",
              "showOtherMoudle"
            ]
          }
        ],
        "longitude": 7,
        "latitude": 8
      },
      {
        "companyId": "216d3310b6c5425191393fd973f376dc",
        "companyName": "贵州分公司",
        "roleId": null,
        "staffId": null,
        "actions": [
          "projectListSalesSecretary",
          "projectListAllMisnister",
          "headBanner",
          "endPressMoney",
          "pressForMoneyList",
          "PressByProject",
          "endPressMoneyDev",
          "pressForMoneyListDev",
          "showOAHandle",
          "logPositionSearch",
          "showLog",
          "showExpandProjectList",
          "showProjectAuditMarkPerson",
          "showExpandProjectFollow",
          "showExpandResList",
          "searchResListPerson",
          "showDeleteResourceBotton",
          "showExpandResFollow",
          "searchResFollow",
          "showExpandPersonInventory",
          "showExpandStatistics",
          "showExpandProjectWaitFollow",
          "showResWaitFollow",
          "showClause",
          "showExpandContract",
          "showExpandWaitReceive",
          "showExpandLog",
          "showExpandPositionSearch",
          "showRecordingModule",
          "searchOther",
          "showResourceGiftList",
          "showSearchList",
          "scoreDifficultyTable",
          "projectOpeningTable",
          "projectStandardTable",
          "showDevelopers",
          "searchOtherDV",
          "showBond",
          "betweenTwoPartiesList",
          "showPaymentApproved",
          "showSalesList",
          "pressForDepositMoneyList",
          "OAInport",
          "lostOrReportedLoss",
          "proCustomerServiceFee",
          "OADevInport",
          "showSheetData",
          "paymentList",
          "showDailyReport",
          "sendGiftMore",
          "showSalaryRank",
          "competitor",
          "projectMsg",
          "proprietorMsg",
          "signingMsg",
          "stockMsg",
          "resourcesMsg",
          "financeMsg",
          "parkingLotMsg",
          "staffMsg",
          "collectionMsg",
          "selfMsg",
          "helpMsg",
          "pressForDepositMoneyListDev",
          "contactDelay",
          "advancePayment",
          "showWorkOrderExpand",
          "showProjectPKList",
          "auditPKList",
          "auditPKBotton",
          "showDevProjectPKList",
          "monthlyReview",
          "showsurveyByQuestionnaireList",
          "investigateReport",
          "developerToBeSupplemented",
          "businessTermsList",
          "friendCircleMaterialExpand",
          "borrowingRecords",
          "borrowingRecordsDev",
          "contractList",
          "devScoreList",
          "mortgageDocumentList",
          "showDetentionBtn",
          "showMortgageDocument",
          "showDetentionBtnDev",
          "replayList",
          "deliver",
          "proCustomerServiceFeeExpand",
          "showToDoList",
          "showExpandCollectProject",
          "showCommercialTerms",
          "showDraftContractList",
          "showCommercialTermsList",
          "showWithdrawalMeeting",
          "withdrawalTimeAudit",
          "showProjectInventoryForPersonal",
          "bankAccountBalance",
          "ProjectFlowAudit",
          "propertyToBeSupplemented",
          "practiseEveryWeekDev",
          "collegeTaskDev",
          "practiseEveryDayDev",
          "showDevelopPKList",
          "importantToDoListSale",
          "importantToDoListDev",
          "replayRecord",
          "showsurveyByQuestionnaireListDev",
          "scanStreetDev",
          "expectSignProjectList",
          "expectSignProjectListOther",
          "reserveProjectsList",
          "resourceTransmitList",
          "replayRecordDev",
          "meetingManageDev",
          "meetingManageSale",
          "showCustomersImport",
          "customerMagAllPerson",
          "businessCardEntrance",
          "businessCardDynamicListEntrance",
          "businessCardRelated",
          "resourceRecommendList"
        ],
        "roleList": [
          {
            "roleId": 3,
            "roleLevel": 2,
            "roleName": "拓展总监",
            "actions": [
              "projectListSalesSecretary",
              "projectListAllMisnister",
              "headBanner",
              "endPressMoney",
              "pressForMoneyList",
              "PressByProject",
              "endPressMoneyDev",
              "pressForMoneyListDev",
              "showOAHandle",
              "logPositionSearch",
              "showLog",
              "showExpandProjectList",
              "showProjectAuditMarkPerson",
              "showExpandProjectFollow",
              "showExpandResList",
              "searchResListPerson",
              "showDeleteResourceBotton",
              "showExpandResFollow",
              "searchResFollow",
              "showExpandPersonInventory",
              "showExpandStatistics",
              "showExpandProjectWaitFollow",
              "showResWaitFollow",
              "showClause",
              "showExpandContract",
              "showExpandWaitReceive",
              "showExpandLog",
              "showExpandPositionSearch",
              "showRecordingModule",
              "searchOther",
              "showResourceGiftList",
              "showSearchList",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "showDevelopers",
              "searchOtherDV",
              "showBond",
              "betweenTwoPartiesList",
              "showPaymentApproved",
              "showSalesList",
              "pressForDepositMoneyList",
              "OAInport",
              "lostOrReportedLoss",
              "proCustomerServiceFee",
              "OADevInport",
              "showSheetData",
              "paymentList",
              "showDailyReport",
              "sendGiftMore",
              "showSalaryRank",
              "competitor",
              "projectMsg",
              "proprietorMsg",
              "signingMsg",
              "stockMsg",
              "resourcesMsg",
              "financeMsg",
              "parkingLotMsg",
              "staffMsg",
              "collectionMsg",
              "selfMsg",
              "helpMsg",
              "pressForDepositMoneyListDev",
              "contactDelay",
              "advancePayment",
              "showWorkOrderExpand",
              "showProjectPKList",
              "auditPKList",
              "auditPKBotton",
              "showDevProjectPKList",
              "monthlyReview",
              "showsurveyByQuestionnaireList",
              "investigateReport",
              "developerToBeSupplemented",
              "businessTermsList",
              "friendCircleMaterialExpand",
              "borrowingRecords",
              "borrowingRecordsDev",
              "contractList",
              "devScoreList",
              "mortgageDocumentList",
              "showDetentionBtn",
              "showMortgageDocument",
              "showDetentionBtnDev",
              "replayList",
              "deliver",
              "proCustomerServiceFeeExpand",
              "showToDoList",
              "showExpandCollectProject",
              "showCommercialTerms",
              "showDraftContractList",
              "showCommercialTermsList",
              "showWithdrawalMeeting",
              "withdrawalTimeAudit",
              "showProjectInventoryForPersonal",
              "bankAccountBalance",
              "ProjectFlowAudit",
              "propertyToBeSupplemented",
              "practiseEveryWeekDev",
              "collegeTaskDev",
              "practiseEveryDayDev",
              "showDevelopPKList",
              "importantToDoListSale",
              "importantToDoListDev",
              "replayRecord",
              "showsurveyByQuestionnaireListDev",
              "scanStreetDev",
              "expectSignProjectList",
              "expectSignProjectListOther",
              "reserveProjectsList",
              "resourceTransmitList",
              "replayRecordDev",
              "meetingManageDev",
              "meetingManageSale",
              "showCustomersImport",
              "customerMagAllPerson",
              "businessCardEntrance",
              "businessCardDynamicListEntrance",
              "businessCardRelated",
              "resourceRecommendList"
            ]
          }
        ],
        "longitude": null,
        "latitude": null
      },
      {
        "companyId": "9a81c7640cda40478a0e45c9d00101fc",
        "companyName": "海南分公司",
        "roleId": null,
        "staffId": null,
        "actions": [
          "projectListSalesSecretary",
          "projectListAllMisnister",
          "headBanner",
          "endPressMoney",
          "pressForMoneyList",
          "PressByProject",
          "endPressMoneyDev",
          "pressForMoneyListDev",
          "showOAHandle",
          "logPositionSearch",
          "showLog",
          "showExpandProjectList",
          "showProjectAuditMarkPerson",
          "showExpandProjectFollow",
          "showExpandResList",
          "searchResListPerson",
          "showDeleteResourceBotton",
          "showExpandResFollow",
          "searchResFollow",
          "showExpandPersonInventory",
          "showExpandStatistics",
          "showExpandProjectWaitFollow",
          "showResWaitFollow",
          "showClause",
          "showExpandContract",
          "showExpandWaitReceive",
          "showExpandLog",
          "showExpandPositionSearch",
          "showRecordingModule",
          "searchOther",
          "showResourceGiftList",
          "showSearchList",
          "scoreDifficultyTable",
          "projectOpeningTable",
          "projectStandardTable",
          "showDevelopers",
          "searchOtherDV",
          "showBond",
          "betweenTwoPartiesList",
          "showPaymentApproved",
          "showSalesList",
          "pressForDepositMoneyList",
          "OAInport",
          "lostOrReportedLoss",
          "proCustomerServiceFee",
          "OADevInport",
          "showSheetData",
          "paymentList",
          "showDailyReport",
          "sendGiftMore",
          "showSalaryRank",
          "competitor",
          "projectMsg",
          "proprietorMsg",
          "signingMsg",
          "stockMsg",
          "resourcesMsg",
          "financeMsg",
          "parkingLotMsg",
          "staffMsg",
          "collectionMsg",
          "selfMsg",
          "helpMsg",
          "pressForDepositMoneyListDev",
          "contactDelay",
          "advancePayment",
          "showWorkOrderExpand",
          "showProjectPKList",
          "auditPKList",
          "auditPKBotton",
          "showDevProjectPKList",
          "monthlyReview",
          "showsurveyByQuestionnaireList",
          "investigateReport",
          "developerToBeSupplemented",
          "businessTermsList",
          "friendCircleMaterialExpand",
          "borrowingRecords",
          "borrowingRecordsDev",
          "contractList",
          "devScoreList",
          "mortgageDocumentList",
          "showDetentionBtn",
          "showMortgageDocument",
          "showDetentionBtnDev",
          "replayList",
          "deliver",
          "proCustomerServiceFeeExpand",
          "showToDoList",
          "showExpandCollectProject",
          "showCommercialTerms",
          "showDraftContractList",
          "showCommercialTermsList",
          "showWithdrawalMeeting",
          "withdrawalTimeAudit",
          "showProjectInventoryForPersonal",
          "bankAccountBalance",
          "ProjectFlowAudit",
          "propertyToBeSupplemented",
          "practiseEveryWeekDev",
          "collegeTaskDev",
          "practiseEveryDayDev",
          "showDevelopPKList",
          "importantToDoListSale",
          "importantToDoListDev",
          "replayRecord",
          "showsurveyByQuestionnaireListDev",
          "scanStreetDev",
          "expectSignProjectList",
          "expectSignProjectListOther",
          "reserveProjectsList",
          "resourceTransmitList",
          "replayRecordDev",
          "meetingManageDev",
          "meetingManageSale",
          "showCustomersImport",
          "customerMagAllPerson",
          "businessCardEntrance",
          "businessCardDynamicListEntrance",
          "businessCardRelated",
          "resourceRecommendList"
        ],
        "roleList": [
          {
            "roleId": 3,
            "roleLevel": 2,
            "roleName": "拓展总监",
            "actions": [
              "projectListSalesSecretary",
              "projectListAllMisnister",
              "headBanner",
              "endPressMoney",
              "pressForMoneyList",
              "PressByProject",
              "endPressMoneyDev",
              "pressForMoneyListDev",
              "showOAHandle",
              "logPositionSearch",
              "showLog",
              "showExpandProjectList",
              "showProjectAuditMarkPerson",
              "showExpandProjectFollow",
              "showExpandResList",
              "searchResListPerson",
              "showDeleteResourceBotton",
              "showExpandResFollow",
              "searchResFollow",
              "showExpandPersonInventory",
              "showExpandStatistics",
              "showExpandProjectWaitFollow",
              "showResWaitFollow",
              "showClause",
              "showExpandContract",
              "showExpandWaitReceive",
              "showExpandLog",
              "showExpandPositionSearch",
              "showRecordingModule",
              "searchOther",
              "showResourceGiftList",
              "showSearchList",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "showDevelopers",
              "searchOtherDV",
              "showBond",
              "betweenTwoPartiesList",
              "showPaymentApproved",
              "showSalesList",
              "pressForDepositMoneyList",
              "OAInport",
              "lostOrReportedLoss",
              "proCustomerServiceFee",
              "OADevInport",
              "showSheetData",
              "paymentList",
              "showDailyReport",
              "sendGiftMore",
              "showSalaryRank",
              "competitor",
              "projectMsg",
              "proprietorMsg",
              "signingMsg",
              "stockMsg",
              "resourcesMsg",
              "financeMsg",
              "parkingLotMsg",
              "staffMsg",
              "collectionMsg",
              "selfMsg",
              "helpMsg",
              "pressForDepositMoneyListDev",
              "contactDelay",
              "advancePayment",
              "showWorkOrderExpand",
              "showProjectPKList",
              "auditPKList",
              "auditPKBotton",
              "showDevProjectPKList",
              "monthlyReview",
              "showsurveyByQuestionnaireList",
              "investigateReport",
              "developerToBeSupplemented",
              "businessTermsList",
              "friendCircleMaterialExpand",
              "borrowingRecords",
              "borrowingRecordsDev",
              "contractList",
              "devScoreList",
              "mortgageDocumentList",
              "showDetentionBtn",
              "showMortgageDocument",
              "showDetentionBtnDev",
              "replayList",
              "deliver",
              "proCustomerServiceFeeExpand",
              "showToDoList",
              "showExpandCollectProject",
              "showCommercialTerms",
              "showDraftContractList",
              "showCommercialTermsList",
              "showWithdrawalMeeting",
              "withdrawalTimeAudit",
              "showProjectInventoryForPersonal",
              "bankAccountBalance",
              "ProjectFlowAudit",
              "propertyToBeSupplemented",
              "practiseEveryWeekDev",
              "collegeTaskDev",
              "practiseEveryDayDev",
              "showDevelopPKList",
              "importantToDoListSale",
              "importantToDoListDev",
              "replayRecord",
              "showsurveyByQuestionnaireListDev",
              "scanStreetDev",
              "expectSignProjectList",
              "expectSignProjectListOther",
              "reserveProjectsList",
              "resourceTransmitList",
              "replayRecordDev",
              "meetingManageDev",
              "meetingManageSale",
              "showCustomersImport",
              "customerMagAllPerson",
              "businessCardEntrance",
              "businessCardDynamicListEntrance",
              "businessCardRelated",
              "resourceRecommendList"
            ]
          }
        ],
        "longitude": null,
        "latitude": null
      },
      {
        "companyId": "a200d4d87f1443e99c81a3adc3a097c0",
        "companyName": "云南分公司",
        "roleId": null,
        "staffId": null,
        "actions": [
          "projectListSalesSecretary",
          "projectListAllMisnister",
          "headBanner",
          "endPressMoney",
          "pressForMoneyList",
          "PressByProject",
          "endPressMoneyDev",
          "pressForMoneyListDev",
          "showOAHandle",
          "logPositionSearch",
          "showLog",
          "showExpandProjectList",
          "showProjectAuditMarkPerson",
          "showExpandProjectFollow",
          "showExpandResList",
          "searchResListPerson",
          "showDeleteResourceBotton",
          "showExpandResFollow",
          "searchResFollow",
          "showExpandPersonInventory",
          "showExpandStatistics",
          "showExpandProjectWaitFollow",
          "showResWaitFollow",
          "showClause",
          "showExpandContract",
          "showExpandWaitReceive",
          "showExpandLog",
          "showExpandPositionSearch",
          "showRecordingModule",
          "searchOther",
          "showResourceGiftList",
          "showSearchList",
          "scoreDifficultyTable",
          "projectOpeningTable",
          "projectStandardTable",
          "showDevelopers",
          "searchOtherDV",
          "showBond",
          "betweenTwoPartiesList",
          "showPaymentApproved",
          "showSalesList",
          "pressForDepositMoneyList",
          "OAInport",
          "lostOrReportedLoss",
          "proCustomerServiceFee",
          "OADevInport",
          "showSheetData",
          "paymentList",
          "showDailyReport",
          "sendGiftMore",
          "showSalaryRank",
          "competitor",
          "projectMsg",
          "proprietorMsg",
          "signingMsg",
          "stockMsg",
          "resourcesMsg",
          "financeMsg",
          "parkingLotMsg",
          "staffMsg",
          "collectionMsg",
          "selfMsg",
          "helpMsg",
          "pressForDepositMoneyListDev",
          "contactDelay",
          "advancePayment",
          "showWorkOrderExpand",
          "showProjectPKList",
          "auditPKList",
          "auditPKBotton",
          "showDevProjectPKList",
          "monthlyReview",
          "showsurveyByQuestionnaireList",
          "investigateReport",
          "developerToBeSupplemented",
          "businessTermsList",
          "friendCircleMaterialExpand",
          "borrowingRecords",
          "borrowingRecordsDev",
          "contractList",
          "devScoreList",
          "mortgageDocumentList",
          "showDetentionBtn",
          "showMortgageDocument",
          "showDetentionBtnDev",
          "replayList",
          "deliver",
          "proCustomerServiceFeeExpand",
          "showToDoList",
          "showExpandCollectProject",
          "showCommercialTerms",
          "showDraftContractList",
          "showCommercialTermsList",
          "showWithdrawalMeeting",
          "withdrawalTimeAudit",
          "showProjectInventoryForPersonal",
          "bankAccountBalance",
          "ProjectFlowAudit",
          "propertyToBeSupplemented",
          "practiseEveryWeekDev",
          "collegeTaskDev",
          "practiseEveryDayDev",
          "showDevelopPKList",
          "importantToDoListSale",
          "importantToDoListDev",
          "replayRecord",
          "showsurveyByQuestionnaireListDev",
          "scanStreetDev",
          "expectSignProjectList",
          "expectSignProjectListOther",
          "reserveProjectsList",
          "resourceTransmitList",
          "replayRecordDev",
          "meetingManageDev",
          "meetingManageSale",
          "showCustomersImport",
          "customerMagAllPerson",
          "businessCardEntrance",
          "businessCardDynamicListEntrance",
          "businessCardRelated",
          "resourceRecommendList"
        ],
        "roleList": [
          {
            "roleId": 3,
            "roleLevel": 2,
            "roleName": "拓展总监",
            "actions": [
              "projectListSalesSecretary",
              "projectListAllMisnister",
              "headBanner",
              "endPressMoney",
              "pressForMoneyList",
              "PressByProject",
              "endPressMoneyDev",
              "pressForMoneyListDev",
              "showOAHandle",
              "logPositionSearch",
              "showLog",
              "showExpandProjectList",
              "showProjectAuditMarkPerson",
              "showExpandProjectFollow",
              "showExpandResList",
              "searchResListPerson",
              "showDeleteResourceBotton",
              "showExpandResFollow",
              "searchResFollow",
              "showExpandPersonInventory",
              "showExpandStatistics",
              "showExpandProjectWaitFollow",
              "showResWaitFollow",
              "showClause",
              "showExpandContract",
              "showExpandWaitReceive",
              "showExpandLog",
              "showExpandPositionSearch",
              "showRecordingModule",
              "searchOther",
              "showResourceGiftList",
              "showSearchList",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "showDevelopers",
              "searchOtherDV",
              "showBond",
              "betweenTwoPartiesList",
              "showPaymentApproved",
              "showSalesList",
              "pressForDepositMoneyList",
              "OAInport",
              "lostOrReportedLoss",
              "proCustomerServiceFee",
              "OADevInport",
              "showSheetData",
              "paymentList",
              "showDailyReport",
              "sendGiftMore",
              "showSalaryRank",
              "competitor",
              "projectMsg",
              "proprietorMsg",
              "signingMsg",
              "stockMsg",
              "resourcesMsg",
              "financeMsg",
              "parkingLotMsg",
              "staffMsg",
              "collectionMsg",
              "selfMsg",
              "helpMsg",
              "pressForDepositMoneyListDev",
              "contactDelay",
              "advancePayment",
              "showWorkOrderExpand",
              "showProjectPKList",
              "auditPKList",
              "auditPKBotton",
              "showDevProjectPKList",
              "monthlyReview",
              "showsurveyByQuestionnaireList",
              "investigateReport",
              "developerToBeSupplemented",
              "businessTermsList",
              "friendCircleMaterialExpand",
              "borrowingRecords",
              "borrowingRecordsDev",
              "contractList",
              "devScoreList",
              "mortgageDocumentList",
              "showDetentionBtn",
              "showMortgageDocument",
              "showDetentionBtnDev",
              "replayList",
              "deliver",
              "proCustomerServiceFeeExpand",
              "showToDoList",
              "showExpandCollectProject",
              "showCommercialTerms",
              "showDraftContractList",
              "showCommercialTermsList",
              "showWithdrawalMeeting",
              "withdrawalTimeAudit",
              "showProjectInventoryForPersonal",
              "bankAccountBalance",
              "ProjectFlowAudit",
              "propertyToBeSupplemented",
              "practiseEveryWeekDev",
              "collegeTaskDev",
              "practiseEveryDayDev",
              "showDevelopPKList",
              "importantToDoListSale",
              "importantToDoListDev",
              "replayRecord",
              "showsurveyByQuestionnaireListDev",
              "scanStreetDev",
              "expectSignProjectList",
              "expectSignProjectListOther",
              "reserveProjectsList",
              "resourceTransmitList",
              "replayRecordDev",
              "meetingManageDev",
              "meetingManageSale",
              "showCustomersImport",
              "customerMagAllPerson",
              "businessCardEntrance",
              "businessCardDynamicListEntrance",
              "businessCardRelated",
              "resourceRecommendList"
            ]
          }
        ],
        "longitude": null,
        "latitude": null
      }
    ],
    "nickName": "ces",
    "masterCompanyId": "0201b4ab530b9ffe2fe72152fe4ab195",
    "masterCompanyName": "成都总公司",
    "qrCode": "http://top-chengdu.oss-cn-chengdu.aliyuncs.com/image/x0uCygJpK0P734b65429c4bfc7cdefac479f144663a3ceb553b1-62c8-4787-a666-5acbaa32ac2b.jpg",
    "pstaffId": "0"
  }
			;//JSON.parse(userInfoJson);

			if(localStorage.getItem("TDY")){
				userInfo1=JSON.parse(localStorage.getItem("TDY"));
			  }


			userInfo1.actions=userInfo1.companyRoleResps[0].actions;
      userInfo1.roleList=userInfo1.companyRoleResps[0].roleList;
		let obj = { userInfo: userInfo1 };
		store.commit("stateFn", obj);
	} else {
		let obj = { userInfo: {} };
		store.commit("stateFn", obj);
	}
	new Vue({
		el: '#app',
		router,
		store,
		render: h => h(App),
	}).$mount('#app');
} else {
	// var userInfoJson = navigator.userAgent.split(" ")[index - 1];
	// var userInfo1 = JSON.parse(userInfoJson);
	// if (userInfo1.staffId == 'df00b9ab6ebc3ab01753f8e00a4b9409' || userInfo1.staffId == '2901deab2008e4c63e3c27116f4f8913' || userInfo1.staffId == '0701b4abe88e958e5f61a51b59438cda'|| userInfo1.staffId == 'bd00f2abc901803f7d94c2405d4c9e49') {
	// 	userInfo1.actions.push('showExpandFinace');
	// 	userInfo1.actions.push('showExpandFinaceAudit');
	// }
	// let obj = { userInfo: userInfo1 };

	// store.commit("stateFn", obj);

	// var thisProjectInfo = navigator.userAgent.split(" ")[index - 2];
	// localStorage.setItem("thisProjectInfo", thisProjectInfo);

	// var userInfoJson = navigator.userAgent.split(" ")[index - 1];
	// var userInfo1 = JSON.parse(userInfoJson);
	// if (userInfo1.staffId == 'df00b9ab6ebc3ab01753f8e00a4b9409' || userInfo1.staffId == '2901deab2008e4c63e3c27116f4f8913' || userInfo1.staffId == '0701b4abe88e958e5f61a51b59438cda'|| userInfo1.staffId == 'bd00f2abc901803f7d94c2405d4c9e49') {
	// 	userInfo1.actions.push('showExpandFinace');
	// 	userInfo1.actions.push('showExpandFinaceAudit');
	// }
	// let obj = { userInfo: userInfo1 };

	// store.commit("stateFn", obj);

	// var thisProjectInfo = navigator.userAgent.split(" ")[index - 2];
	// localStorage.setItem("thisProjectInfo", thisProjectInfo);
	function reloadAgin(isCountinue){
	SXApi.call(
		function (suc) {
		  if (suc.data && suc.data.data) {
			localStorage.setItem(
			  "thisProjectInfo",
			  suc.data.data
			);
		  }
		},
		null,
		"FunctionPlugin",
		"get_location",
		{
		  key: "thisProjectInfo",
		}
	  );
	  SXApi.call(
		function (suc) {
		  if (suc.data && suc.data.data) {
			let userInfo1 = JSON.parse(suc.data.data);
			if (userInfo1.staffId == 'df00b9ab6ebc3ab01753f8e00a4b9409' || userInfo1.staffId == '2901deab2008e4c63e3c27116f4f8913' || userInfo1.staffId == '0701b4abe88e958e5f61a51b59438cda' || userInfo1.staffId == 'bd00f2abc901803f7d94c2405d4c9e49' || userInfo1.staffId == 'b38745e3ccfa482e901a67bd82ee0bce'|| userInfo1.staffId == '0701b4ab95191bc1123340c61b439cb7'|| userInfo1.staffId == '0a01b4ab63f2f15e5ff3dc1055498eb0'|| userInfo1.staffId == '33012fac02c9d6889ef00d6b4540aab6') {
				userInfo1.actions.push('showExpandFinace');
				userInfo1.actions.push('showExpandFinaceAudit');
			}
			if(userInfo1.staffId == 'df00b9ab6ebc3ab01753f8e00a4b9409'||userInfo1.staffId == '2901deab2008e4c63e3c27116f4f8913'||userInfo1.staffId == 'bd00f2abc901803f7d94c2405d4c9e49'||userInfo1.staffId == '0701b4abe88e958e5f61a51b59438cda'){
				userInfo1.actions.push('bankAccountBalanceDev');
				userInfo1.actions.push('bankAccountBalanceDevAllCompanyInfo');
			}
			let obj = { userInfo: userInfo1 };
			store.commit("stateFn", obj);
			new Vue({
			  el: '#app',
			  router,
			  store,
			  render: h => h(App),
			}).$mount('#app');
		  }else{
			// alert("失败");
			// if(isCountinue){
			//   setTimeout(() => {
			//     reloadAgin(false);
			//   }, 200);
			// }
		  }
		},
		null,
		"FunctionPlugin",
		"get_location",
		{
		  key: "userInfo",
		}
	  );
	}
	document.addEventListener('deviceready',function(){
		reloadAgin(true);
	  },false);
}

/* eslint-disable no-new */




// WEBPACK FOOTER //
// ./src/main.js